import { render, staticRenderFns } from "./ExportToWordButton.vue?vue&type=template&id=2c583a1b&scoped=true&"
import script from "./ExportToWordButton.vue?vue&type=script&lang=js&"
export * from "./ExportToWordButton.vue?vue&type=script&lang=js&"
import style0 from "./ExportToWordButton.vue?vue&type=style&index=0&id=2c583a1b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c583a1b",
  null
  
)

export default component.exports